export default __webpack_public_path__ + "static/media/african3.07339257.jpg";